import Vue from 'vue'
import Join from './join.vue'
import {Cascader, Alert, MessageBox, Message, Icon} from 'element-ui';
import '@/common/config.js'
import utils from '@/common/js/utils.js'
// 引入公共CSS文件
import '@/common/app.css';
import 'swiper/css/swiper.min.css';
import '@/common/element-variables.scss'

Vue.use(Cascader)
Vue.use(Alert)
Vue.use(Icon);
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$message = Message;

Vue.prototype.$util = utils;

new Vue({
    render: h => h(Join),
}).$mount('#app')